var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('basic-home'),(_vm.dialogTerms)?_c('terms',{attrs:{"dialog":_vm.dialogTerms,"title":_vm.$t('common.termsDialogTitle'),"html-text":_vm.termsConditionText},on:{"closeDialog":function($event){_vm.dialogTerms = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }